import { useEffect, useState } from 'react';
import useDominantSpeaker from './useDominantSpeaker';
import useVideoContext from './useVideoContext';
export default function useParticipants() {
  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room;

  var dominantSpeaker = useDominantSpeaker();

  var _useState = useState(room.participants ? Array.from(room.participants.values()) : []),
      participants = _useState[0],
      setParticipants = _useState[1]; // When the dominant speaker changes, they are moved to the front of the participants array.
  // This means that the most recent dominant speakers will always be near the top of the
  // ParticipantStrip component.


  useEffect(function () {
    if (dominantSpeaker) {
      setParticipants(function (prevParticipants) {
        return [dominantSpeaker].concat(prevParticipants.filter(function (participant) {
          return participant !== dominantSpeaker;
        }));
      });
    }
  }, [dominantSpeaker]);
  useEffect(function () {
    var participantConnected = function participantConnected(participant) {
      return setParticipants(function (prevParticipants) {
        return [].concat(prevParticipants, [participant]);
      });
    };

    var participantDisconnected = function participantDisconnected(participant) {
      return setParticipants(function (prevParticipants) {
        return prevParticipants.filter(function (p) {
          return p !== participant;
        });
      });
    };

    room.on('participantConnected', participantConnected);
    room.on('participantDisconnected', participantDisconnected);
    return function () {
      room.off('participantConnected', participantConnected);
      room.off('participantDisconnected', participantDisconnected);
    };
  }, [room]);
  return participants;
}